import {
  ApiResponse,
  BlessedResponse,
  RegistrationApproval,
} from "../types/seatApproval";
import { getCall, postCall, putCall } from "./apiService";

export class ApiService {
  // private static baseUrl = '/api'; // Replace with your actual API base URL

  static async getRegistrationApprovals(params: {
    id?: number; // Optional ID for specific registration approval
    programId: number;
    limit: number;
    offset: number;
    search?: string;
    gender?: string;
    kpiFilter?: string; // Optional preferred program ID for filtering
    mahatriaChoice?: boolean; // Optional flag for Mahatria's choice
    approvalStatus?: string;
    swapRequests?: string;
    shiftRequests?: string; // Optional shift requests for the API call
    appliedFilters?: any; // Optional filters for the API call
    kpifilters?: any; // Additional filters for the API call
    setOverlayLoader?: (loading: boolean) => void; // Optional function to set overlay loading state
  }): Promise<ApiResponse> {
    console.log("getRegistrationApprovals params", params, params.kpifilters);

    const filters: any = {
      kpiCategory: params?.approvalStatus,
      kpiFilter: params?.kpiFilter,
      ...(params?.kpifilters || {}), // Spread the kpifilters object if it exists
    };

    console.log("filterssss", filters);

    // Add gender filter for allocated status
    if (params.approvalStatus === "allocated" && params.gender) {
      console.log("Adding");
      filters.gender = params.gender;
    }
    // ...existing code...

    if (params.swapRequests || params?.shiftRequests) {
      filters.swapRequests = [];
      if (params.swapRequests) {
        filters.swapRequests.push(params?.swapRequests);
      }
      if (params?.shiftRequests) {
        filters.swapRequests.push(params?.shiftRequests);
      }
    }
    // ...existing code...
    if (params.appliedFilters) {
      // Merge applied filters into the filters object
      Object.assign(filters, params.appliedFilters);
    }

    const queryParams = new URLSearchParams({
      programId: params.programId.toString(),
      limit: params.limit.toString(),
      offset: params.offset.toString(),
      filters: JSON.stringify(filters),
      ...(params.search ? { searchText: params.search } : {}), // Changed 'search' to 'searchText'
    }).toString();

    // Mock response for development
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve({
    //       statusCode: 200,
    //       message: "Registration approvals retrieved successfully",
    //       data: {
    //         data: this.generateMockData(params.offset, params.limit),
    //         pagination: {
    //           totalPages: 10,
    //           pageNumber: Math.floor(params.offset / params.limit) + 1,
    //           pageSize: params.limit,
    //           totalRecords: 100,
    //           numberOfRecords: params.limit
    //         }
    //       }
    //     });
    //   }, 1000);
    // });

    // Actual API call (uncomment when ready) /registration-approvals?${queryParams}
    params.setOverlayLoader && params.setOverlayLoader(true);
    const response = await getCall(`registration/mahatria-kpis?${queryParams}`);
    if (response?.data?.statusCode === 200) {
      params.setOverlayLoader && params.setOverlayLoader(false);
    }
    return response;
  }
  static async getSeekerDetails(
    registrationId: number,
  ): Promise<RegistrationApproval> {
    const response = await getCall(
      `registration/mahatria-kpis/${registrationId}`,
    );
    return response;
  }

  static async getProgramByID(params: {
    programId: number;
  }): Promise<ApiResponse> {
    const queryParams = new URLSearchParams({
      programId: params.programId.toString(),
    });
    console.log("getProgramByID", queryParams.toString());
    const response = await getCall(`program/${params.programId}`);
    return response;
  }

  static async blessUser(
    registrationId: number,
    payload: any,
  ): Promise<BlessedResponse> {
    // Mock API call
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve({
    //       success: true,
    //       message: `User with registration ID ${registrationId} has been blessed successfully`
    //     });
    //   }, 500);
    // });

    // Actual API call (uncomment when ready)

    // const response = await fetch(`${this.baseUrl}/bless-user`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({ registrationId })
    // });
    // return response.json();

    const response = await putCall(
      `registration-approval/by-registration/${registrationId}`,
      payload,
    );
    return response;
  }

  static async blessSwapUser(payload: any): Promise<BlessedResponse> {
    const response = await postCall(
      "program-registration/swap/direct",
      payload,
    );
    return response;
  }

  private static generateMockData(
    offset: number,
    limit: number,
  ): RegistrationApproval[] {
    const mockData: RegistrationApproval[] = [];
    const names = [
      "Anjali Kumari",
      "Anjan Kumar",
      "Baskar Sharma",
      "Priya Singh",
      "Rahul Gupta",
      "Sneha Patel",
    ];
    const cities = [
      "Bangalore",
      "Chennai",
      "Hyderabad",
      "Mumbai",
      "Delhi",
      "Pune",
    ];
    const genders: ("male" | "female")[] = ["male", "female"];

    for (let i = 0; i < limit; i++) {
      const index = offset + i;
      const name = names[index % names.length];
      const city = cities[index % cities.length];
      const gender = genders[index % genders.length];

      mockData.push({
        id: (index + 1).toString(),
        registrationId: (200 + index).toString(),
        approvalStatus: "pending",
        approvalDate: null,
        approvedBy: null,
        rejectionReason: null,
        reviewerComments: null,
        autoApproved: false,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        deletedAt: null,
        registration: {
          id: (200 + index).toString(),
          program: {
            id: 192,
            typeId: 6,
            name: "HDB/MSD 2025-2026",
            code: "HDB2025",
            description: "Human Development & Management Skills Development",
            modeOfOperation: "offline",
            meta: {
              price: [{ HDB: 200 }, { MSD: 100 }],
            },
            noOfSession: 2,
          },
          userId: 9000 + index,
          programRegistrationSeqNumber: null,
          waitingListSeqNumber: null,
          registrationStatus: "pending_approval",
          basicDetailsStatus: "completed",
          registrationDate: new Date().toISOString(),
          cancellationDate: null,
          cancelledBy: null,
          rmContact: 8319,
          preferredRoomMate: null,
          fullName: name,
          gender: gender,
          mobileNumber: `98765${(43210 + index).toString().slice(-5)}`,
          emailAddress: `${name.toLowerCase().replace(" ", ".")}@example.com`,
          dob: `199${0 + (index % 10)}-0${1 + (index % 9)}-${(10 + (index % 20)).toString().padStart(2, "0")}`,
          infinitheismContact: null,
          city: city,
          notes: `Notes for ${name}`,
          termsAccepted: true,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          deletedAt: null,
        },
      });
    }

    return mockData;
  }

  static async getSeekersForSwap(params: {
    search?: string;
    programId: number;
    subProgramId: number;
    limit: number;
    offset: number;
  }): Promise<void> {
    const queryParams = new URLSearchParams({
      limit: params.limit.toString(),
      offset: params.offset.toString(),
      ...(params.search ? { search: params.search } : {}),
    }).toString();

    const response = await getCall(
      `program-registration/${params.programId}/sub-program/${params.subProgramId}?${queryParams}`,
    );
    return response;
  }

  static async updateSwapRequest(
    swapRequestId: number,
    payload: any,
  ): Promise<any> {
    const response = await putCall(
      `program-registration/swap/${swapRequestId}`,
      payload,
    );
    return response;
  }
}
